const env = ((window as any).commonEnv || {}) as CommonEnvType

export default env
